class Validator {
  static isPhone(val) {
    return new RegExp(/^\d{10}$/).test(val) ? "valid" : "invalid";
  }
  static isEmail(val) {
    return new RegExp(
      /^[a-z0-9][a-z0-9-_.+]+@([a-z-]|[a-z0-9-]?[a-z0-9-]+[a-z0-9-])\.[a-z0-9-]{2,20}(?:\.[a-z-]{2,20})?(?:\.[a-z-]{2,20})?(?:\.[a-z-]{2,20})?$/i,
    ).test(val)
      ? "valid"
      : "invalid";
  }
  // static isEmailDomain(val){
  //     let testEmailText = false;
  //     if(!val.toLowerCase().startsWith('@'))
  //     {
  //         testEmailText = new RegExp(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+$/i).test(val.split('@')[0].toLowerCase());
  //     }

  //     return (testEmailText && !val.toLowerCase().startsWith('@') && val.toLowerCase().endsWith('@'+window.adobeIMS.getUserProfile().email.split('@')[1].toLowerCase())) ? "valid" : "invalid" ;
  // }
  static isEmailDomain(val) {
    let testEmailText;
    testEmailText =
      !val.toLowerCase().startsWith("@") &&
      val
        .toLowerCase()
        .endsWith(
          "@" +
            window.adobeIMS.getUserProfile().email.split("@")[1].toLowerCase(),
        )
        ? "valid"
        : "invalid";
    if (testEmailText == "invalid") {
      return testEmailText;
    } else {
      return new RegExp(
        /^[a-z0-9][a-z0-9-_.+]+@([a-z-]|[a-z0-9-]?[a-z0-9-]+[a-z0-9-])\.[a-z0-9-]{2,20}(?:\.[a-z-]{2,20})?(?:\.[a-z-]{2,20})?(?:\.[a-z-]{2,20})?$/i,
      ).test(val)
        ? "valid"
        : "invalid";
    }
  }
  static isWebURL(val) {
    return new RegExp(
      /^((https?|ftp|smtp):\/\/)?(www.)?(.)*\.[a-z]+(\.[a-zA-Z]+)?(\/[a-zA-Z0-9#]+\/?)*$/i,
    ).test(val)
      ? "valid"
      : "invalid";
  }
  static isValidList(val) {
    if (val && val.length > 0) {
      return true;
    }
    return false;
  }
  static isYear(val) {
    let retVal = "invalid";
    if (new RegExp(/^\d{4}$/).test(val)) {
      const curYear = new Date().getFullYear();
      if (Number(val) >= 1900 && Number(val) <= curYear) {
        retVal = "valid";
      }
    }
    return retVal;
  }
  static isString(val) {
    if (val && val.trim().length > 0) {
      return "valid";
    }
    return "invalid";
  }

  /** Optional contact prefix: empty OK; >10 chars invalidMaxLength; whitespace-only invalidWhitespace. */
  static prefixContactField(val) {
    if (val === undefined || val === null || val === "") {
      return "valid";
    }
    const s = typeof val === "string" ? val : String(val);
    if (s.length > 10) {
      return "invalidMaxLength";
    }
    if (s.trim().length === 0) {
      return "invalidWhitespace";
    }
    return "valid";
  }

  /** Optional contact suffix/title: same rules as {@link prefixContactField}. */
  static suffixContactField(val) {
    return Validator.prefixContactField(val);
  }


  static disallowDomainValidationForString(val) {
    if (this.isString(val) === "invalid") {
      return "invalid";
    } else {
      return this.domainValidation(val);
    }
    return "valid";
  }

  static domainValidation(val) {
    if (val.toLowerCase().includes("adobe")) {
      return "invalid";
    }
    return "valid";
  }

  static disallowDomainValidationForWeb(val) {
    if (this.isWebURL(val) === "invalid") {
      return "invalid";
    } else {
      return this.domainValidation(val);
    }
    return "valid";
  }

  static isValidPercent(val) {
    if (
      val &&
      Boolean(parseInt(val)) &&
      parseInt(val) >= 5 &&
      parseInt(val) <= 100
    ) {
      return "valid";
    }
    return "invalid";
  }

  // static isValidWebsite(val) {
  //   // return new RegExp(
  //   //   /^(?:(?:https?|ftp|smtp):\/\/)?(www\.)?[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+(?:[\/?#][A-Za-z0-9\-._~!$&'()*+,;=:@%\/?]*)?$/
  //   // ).test(val)
  //   //   ? "valid"
  //   //   : "invalid";

  //   // Regex to validate website url

  //   return new RegExp(
  //     /^(?:(?:https?|ftp|smtp):\/\/)?(www\.)?(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:[\/?#][A-Za-z0-9\-._~!$&'()*+,;=:@%\/?]*)?$/
  //   ).test(val)
  //     ? "valid"
  //     : "invalid";
  // }

  static isValidWebsite(url) {
    if (!url) return "invalid";

    const BASIC_URL_REGEX =
      /^(?:(?:https?|ftp|smtp):\/\/)?(?:www\.)?([a-z0-9.-]+)\.([a-z]{2,})([\/?#].*)?$/i;

    const input = url.trim().toLowerCase();

    // Block fake protocol like "https-chann-elpartners..."
    if (/^https?-/.test(input)) return "invalid";

    const match = input.match(BASIC_URL_REGEX);
    if (!match) return "invalid";

    // Extract hostname (no protocol, no path, no query, no hash)
    const host = input
      .replace(/^(https?|ftp|smtp):\/\//, "")
      .split(/[\/?#]/)[0];

    const hostLabels = host.split(".");

    // Reject www.test (only www + tld)
    if (hostLabels[0] === "www" && hostLabels.length === 2) return "invalid";

    // Domain label checks (excluding TLD)
    const domainLabels = hostLabels.slice(0, -1);

    for (const label of domainLabels) {
      if (!label.length) return "invalid";
      if (!/^[a-z0-9-]+$/.test(label)) return "invalid";
      if (label.startsWith("-") || label.endsWith("-")) return "invalid";
      if (label.includes("--")) return "invalid";
      if (/^-+$/.test(label)) return "invalid";
    }

    // TLD must not be numeric
    const tld = hostLabels[hostLabels.length - 1];
    if (!/^[a-z]{2,}$/.test(tld)) return "invalid";

    // '#' allowed only if '/' exists before it
    const hashIndex = input.indexOf("#");
    if (hashIndex !== -1) {
      const slashIndex = input.indexOf("/", input.indexOf(host));
      if (slashIndex === -1 || slashIndex > hashIndex) return "invalid";
    }

    // Block path containing "-.-"
    if (/\/.*-\.-/.test(input)) return "invalid";

    return "valid";
  }

  static isValidPhoneNumber(val) {
    if (!val || !val?.trim()) return "invalid";
    const phoneRegex = /^[+]?[()]?\d{3}[)]?[-\s.]?\d{3}[-\s.]?\d{4,6}$/;
    return phoneRegex.test(val?.trim()) ? "valid" : "invalid";
  }
}

export default Validator;
